export var TestFrequency;
(function (TestFrequency) {
    TestFrequency["Adhoc"] = "adhoc";
    TestFrequency["Annually"] = "annually";
    TestFrequency["Biannually"] = "biannually";
    TestFrequency["Daily"] = "daily";
    TestFrequency["Fortnightly"] = "fortnightly";
    TestFrequency["FourWeekly"] = "fourweekly";
    TestFrequency["Monthly"] = "monthly";
    TestFrequency["Quarterly"] = "quarterly";
    TestFrequency["Weekly"] = "weekly";
})(TestFrequency || (TestFrequency = {}));
//# sourceMappingURL=test-frequency.js.map